module.exports = __webpack_public_path__ + "img/lu.c858787c.svg";